var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload-opus"},[_c('div',{staticClass:"upload-con"},[_c('div',{staticClass:"upload-suss-title"},[_c('p',{staticClass:"title"},[_vm._v("很抱歉！您来晚了")]),_c('p',[_vm._v("作品上传已截至")])])])])
}]

export { render, staticRenderFns }